import { Galeria } from "../../components";
import "./stylesGaleria.scss";

export const GaleriaPage = () => <Galeria />;
